enum CeDocumentStatus {
  Existing = 'existing',
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Failed = 'failed',
}

export default CeDocumentStatus;
